import { digitsEnToFa } from "@persian-tools/persian-tools";
import moment from "jalali-moment";
import { useState } from "react";
import CustomDate from "./CustomDate";

interface filterProps {
  showFilter: string;
  setFrom: any;
  setTo: any;
  setShowFilter: any;
}

function FilterDays({
  showFilter,
  setFrom,
  setTo,
  setShowFilter,
}: filterProps) {
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 59, 999);

  const [showDatePicker, setShowDatePicker] = useState(false);
  const now = new Date();

  return (
    <>
      <div className="flex items-center justify-between mt-4">
        <div className="item w-1/4 px-2">
          <div
            className={` border border-gray-100-mmpz py-2 px-1 rounded-2xl text-[12px] cursor-pointer text-center ${
              showFilter == "امروز" ? "bg-primary-300 text-white" : "bg-white"
            } `}
            onClick={() => {
              setShowFilter("امروز");
              setFrom(startOfToday.getTime());
              setTo(endOfToday.getTime());
            }}
          >
            امروز
          </div>
        </div>
        <div className="item w-1/4 px-2">
          <div
            className={` border border-gray-100-mmpz py-2 px-1 rounded-2xl text-[12px] cursor-pointer text-center ${
              showFilter == "7 روز" ? "bg-primary-300 text-white" : "bg-white"
            } `}
            onClick={() => {
              const todayStart = moment().subtract(1, "weeks").startOf("week");
              setFrom(todayStart.valueOf());
              setTo(now.valueOf());
              setShowFilter("7 روز");
            }}
          >
            {digitsEnToFa("7")} روز پیش
          </div>
        </div>
        <div className="item w-1/4 px-2">
          <div
            className={` border border-gray-100-mmpz py-2 px-1 rounded-2xl text-[12px] cursor-pointer text-center ${
              showFilter == "90 روز" ? "bg-primary-300 text-white" : "bg-white"
            } `}
            onClick={() => {
              const todayStart = moment()
                .subtract(3, "months")
                .startOf("month");
              setFrom(todayStart.valueOf());
              setTo(now.valueOf());
              setShowFilter("90 روز");
            }}
          >
            {digitsEnToFa("90")} روز پیش
          </div>
        </div>
        <div className="item w-1/4 px-2">
          <div
            className={` border border-gray-100-mmpz py-2 px-1 rounded-2xl text-[12px] cursor-pointer text-center ${
              !["امروز", "7 روز", "90 روز"].includes(showFilter)
                ? "bg-primary-300 text-white"
                : "bg-white"
            } `}
            onClick={() => setShowDatePicker(true)}
          >
            تاریخ دلخواه
          </div>
        </div>
      </div>

      {showDatePicker && (
        <CustomDate
          setFrom={setFrom}
          setTo={setTo}
          setShowFilter={setShowFilter}
          onClose={() => setShowDatePicker(false)}
        />
      )}
    </>
  );
}

export default FilterDays;
